import React, { FunctionComponent } from 'react';
import { Modal, Header } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { useForm, FormProvider } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';
import { useMutation } from 'helpers/useMutation';

import styles from './ToggleVenuesModal.styles';
import TOGGLE_VENUE_BY_OFFER_UUID from './ToggleVenuesModal.mutations';

type MatchParams = {
  merchantName: string;
  merchantId: string;
  offerUuid: string;
};

type Styles = ClassProp<ReturnType<typeof styles>>;

type FormData = {
  toggleTransactions: string;
};

type Props = {
  classes: Styles;
  title?: string;
};

const ToggleVenuesModal: FunctionComponent<Props> = ({
  title = 'Toggle Venue Transactions',
  classes,
}) => {
  const { runMutation, loading: loadingMutation } = useMutation(
    TOGGLE_VENUE_BY_OFFER_UUID,
    {},
    'Toggled Venue Transactions',
  );

  const methods = useForm<FormData>({
    mode: 'onBlur',
  });
  const { register, handleSubmit, errors } = methods;

  // get offer uuid
  const params = useParams<MatchParams>();
  const { offerUuid }: MatchParams = params;

  const onSubmit = async ({ toggleTransactions }: FormData) => {
    runMutation({
      variables: {
        params: {
          offerUuid,
          mode: toggleTransactions,
        },
      },
    });
  };

  return (
    <Modal
      trigger={
        <button className={classes.button}>Toggle Venue Transactions</button>
      }
      closeIcon
      size="mini"
    >
      <Header className={classes.header} content={title} />
      <Modal.Content>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.fieldGroup}>
              <input
                type="radio"
                id="toggleTransactionsOn"
                name="toggleTransactions"
                value="TURN_ON"
                ref={register}
              />
              <label className={classes.label} htmlFor="toggleTransactionsOn">
                ON
              </label>
            </div>
            <br />
            <div className={classes.fieldGroup}>
              <input
                type="radio"
                id="toggleTransactionsOff"
                name="toggleTransactions"
                value="TURN_OFF"
                ref={register}
              />
              <label className={classes.label} htmlFor="toggleTransactionsOff">
                OFF
              </label>
            </div>
            <br />

            <div className={classes.fieldGroup}>
              <input
                type="submit"
                value={loadingMutation ? 'Loading..' : 'Submit'}
                className={classnames(classes.submit, {
                  [classes.disabled]: !!errors,
                })}
              />
            </div>
          </form>
        </FormProvider>
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(ToggleVenuesModal);
